import ITranslation from "../../interface/translation";
import Message from "../../enum/message";

export default {
    id: 'en',
    name: 'English',
    msg: {
        [Message.mins]: 'mins',
        [Message.checktrue]: 'Yes',
        [Message.checkfalse]: 'No',
        [Message.checkindetermine]: 'Unknown',
        [Message.fieldfrom]: 'Starts on',
        [Message.fieldto]: 'Ends on',
        [Message.fieldduration]: 'Duration',
        [Message.dateonly]: 'Date Only',
        [Message.timeonly]: 'Time Only',
        [Message.record]: 'Record',
        [Message.owner]: 'Owner',
        [Message.defaulttablename]: 'New Table',
        [Message.defaultfieldname]: 'New Field',
        [Message.emptyevent]: '',
        [Message.globalview]: 'All',
        [Message.overdue]: 'Overdue',
        [Message.notavailable]: 'N/A',
        [Message.supportname]: 'FrameLink support',
        [Message.total]: 'Total',
        [Message.backup]: 'Backup',
        [Message.emptysheet]: 'No name',
        [Message.verifyemailtitle]: 'Address Verification',
        [Message.verifyemailtext]: 'Thank you for using FrameLink!\nClick on the «Verify» button below to become an authorized FrameLink email sender.\nIf you do not know where this message is coming from, please ignore it.',
        [Message.verifyemailsubmit]: 'Verify',
        [Message.verifyphonetext]: 'Thank you for using FrameLink! Click this link [VERIFICATION_LINK] to verify your phone number',
        [Message.gdprallow]: 'Allow',
        [Message.gdprdecline]: 'Decline',
        [Message.copy]: 'Copy of',
        [Message.publicformnotification]: 'Public Form Notification'
    }
} as ITranslation;